// extracted by mini-css-extract-plugin
export default {"header":"styles_header__1wf-3","panel":"styles_panel__qvWbv","panelIcon":"styles_panelIcon__kCLbU","InvestorKit":"styles_InvestorKit__lNzlV"};